module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-24-9790af89305fe949e1962396b66c44ad.svg";